import { logUsage } from 'owa-analytics';
import { isFeatureEnabled } from 'owa-feature-flags';
import PontType from 'owa-service/lib/contract/PontType';
import {
    embargoedMarkets,
    getAdMarketPublishGroupCode,
    isAdPontEnabled,
    IsChildConsumerUser,
    IsPremiumConsumerUser,
    IsShadowMailboxUser,
    supportedMarkets,
} from './sharedAdsUtils';

var showDisplayAds: boolean;
export function areDisplayAdsEnabled(): boolean {
    // caching this value as it doesn't change per session
    if (typeof showDisplayAds != 'undefined') {
        return showDisplayAds;
    }

    if (!isFeatureEnabled('fwk-ads')) {
        showDisplayAds = false;
    } else {
        let adsNotEnabledString = null;
        let adMarket = getAdMarketPublishGroupCode();

        // Make sure they have the AdsExperiments bit set and Display on is not set, then don't show ads
        if (!isAdPontEnabled(PontType.AdsDisplayOn)) {
            adsNotEnabledString = 'Experiment';
        } else if (IsPremiumConsumerUser() || IsShadowMailboxUser()) {
            adsNotEnabledString = 'AdPaidUser';
        } else if (embargoedMarkets.includes(adMarket)) {
            adsNotEnabledString = 'EmbargoedMarket';
        } else if (
            isFeatureEnabled('fwk-ads-disableDefaultPG') &&
            !supportedMarkets.includes(adMarket)
        ) {
            adsNotEnabledString = 'NonSupportedMarket';
        } else if (IsChildConsumerUser()) {
            adsNotEnabledString = 'ChildAccount';
        }

        showDisplayAds = adsNotEnabledString == null;
        if (showDisplayAds) {
            logUsage('AdsbarEnabled', {
                market: adMarket,
            });
        } else {
            logUsage('AdsbarNotEnabled', {
                owa_1: adsNotEnabledString,
                market: adMarket,
            });
        }
    }

    return showDisplayAds;
}

export function setShowAds(value: any) {
    showDisplayAds = value;
}
